import { useClientTerminology } from '@/views/list/NetworkTerms';
import { RiskRating } from '@/components';
import { Rating } from '@/features/types';
import { getRatingId } from '@/helpers/encroachmentRating';

export const FuelHazardRating = ({
  rating,
  score,
  variant,
}: {
  rating: Rating;
  score?: number | null;
  variant?: 'primary' | 'secondary';
}) => {
  const intl = useClientTerminology();

  const ratingLabel = intl.formatMessage({
    id: getRatingId(rating),
  });

  // "None" usually means a null score, but the backend also assigns it when
  // the client's score range collapses (max == min), where a score exists.
  // Never pair a number with "None" — the label would contradict itself.
  const label =
    score == null || rating === Rating.None
      ? ratingLabel
      : `${ratingLabel} (${intl.formatNumber(score, {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        })})`;

  return <RiskRating rating={rating} label={label} variant={variant} />;
};
